import axiosInstance from './api';

export const postEnquiry = (data) => {
  return axiosInstance.post('/enquiries', data)
}